import { JwtHelperService } from '@auth0/angular-jwt';

export const SUPER_ADMIN_EMAIL = 'superadmin@aceenergie.com';

export function isSuperAdminClaims(claims: Record<string, unknown> | null): boolean {
    const emails = [claims?.email, claims?.Email,
        claims?.['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress'],
        claims?.preferred_username, claims?.unique_name];
    return emails.some(email => typeof email === 'string' && email.toLowerCase() === SUPER_ADMIN_EMAIL);
}

/** The authenticated SuperAdmin email is sufficient; no role claim or SICA profile is required. */
export function hasSuperAdminRole(): boolean {
    const token = localStorage.getItem('accessToken');
    if (!token) return false;
    try {
        return isSuperAdminClaims(new JwtHelperService().decodeToken(token));
    } catch {
        return false;
    }
}

export function hasSuperAdminSettingsAccess(link: string): boolean {
    const path = (link || '').toLowerCase();
    return (path === '/settings' || path.startsWith('/settings/')) && hasSuperAdminRole();
}
